import dayjs from 'dayjs';
import { PROVIDER_SOURCE } from '../../constants/quote';
import { QuoteStatus } from '../../shared/generated';
export var judgeIsNeedToSignProviderQuote = function judgeIsNeedToSignProviderQuote(providerCode) {
  return [PROVIDER_SOURCE().GREATEAMERICAN.value, PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value].includes(providerCode);
};
export var judgeQuoteIsAfterPurchasedStatus = function judgeQuoteIsAfterPurchasedStatus(status) {
  return [QuoteStatus.PURCHASED, QuoteStatus.SUBSCRIPTION_PAYMENT_FAILED, QuoteStatus.PRE_PAYMENT, QuoteStatus.DIRECT_DEBIT_SETUP_SUCCESS].includes(status);
};
export var judgeCanDeleteQuote = function judgeCanDeleteQuote(data) {
  return !([QuoteStatus.PAYMENT_PENDING, QuoteStatus.PAYMENT_PROCESSING, QuoteStatus.PURCHASE_FAILED].includes(data === null || data === void 0 ? void 0 : data.status) || judgeQuoteIsAfterPurchasedStatus(data === null || data === void 0 ? void 0 : data.status));
};
export var getLocalQuoteProjectEndDate = function getLocalQuoteProjectEndDate(data) {
  if (!(data !== null && data !== void 0 && data.projectPeriodStart)) {
    return null;
  }

  return [PROVIDER_SOURCE().GREATEAMERICAN.value, PROVIDER_SOURCE().GREATEAMERICAN_BUSINESS_INSURANCE.value].includes(data === null || data === void 0 ? void 0 : data.providerCode) ? dayjs(data === null || data === void 0 ? void 0 : data.projectPeriodStart).add(1, 'year').toDate() : dayjs(data === null || data === void 0 ? void 0 : data.projectPeriodStart).add(1, 'year').subtract(1, 'day').toDate();
};